import type { SummarizeFile } from '@/modules/common/adapters/summarize-file.type.ts';

export class SummarizeFileAdapter {
  static map(response: any): SummarizeFile {
    return {
      summary: response.summary,
    };
  }
}
